<app-uni-page [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate" pageTitle="Product Search"> </app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex h-full flex-col">
    <!-- Section 1: Text Filters -->
    <div class="qb-detail-card qb-primary-tint mx-4 mb-2 mt-2 w-1/2 shrink-0 p-3">
      <div class="grid grid-cols-12 gap-3">
        <uni-field class="col-span-6" label="Manufacturer">
          <input type="text" pInputText title="Manufacturer" [(ngModel)]="manufacturerName" (change)="onWhereChange()" />
          <p-dropdown
            extendedLabel
            class="small-dropdown"
            [options]="filterQueryOps"
            [(ngModel)]="manufacturerOp"
            optionLabel="name"
            dataKey="name"
            placeholder="Select a filter"
            (onChange)="onWhereChange()"
          >
          </p-dropdown>
        </uni-field>
        <uni-field class="col-span-6" label="Style">
          <input type="text" pInputText title="Style" [(ngModel)]="productTypeStyle" (change)="onWhereChange()" />
          <p-dropdown
            extendedLabel
            class="small-dropdown"
            [options]="filterQueryOps"
            [(ngModel)]="productTypeStyleOp"
            optionLabel="name"
            dataKey="name"
            placeholder="Select a filter"
            (onChange)="onWhereChange()"
          >
          </p-dropdown>
        </uni-field>
      </div>
      <div class="mt-2 grid grid-cols-12 gap-3">
        <uni-field class="col-span-6" label="Product Description">
          <input type="text" pInputText title="Product Description" [(ngModel)]="productTypeDescription" (change)="onWhereChange()" />
          <p-dropdown
            extendedLabel
            class="small-dropdown"
            [options]="filterQueryOps"
            [(ngModel)]="productTypeDescriptionOp"
            optionLabel="name"
            dataKey="name"
            placeholder="Select a filter"
            (onChange)="onWhereChange()"
          >
          </p-dropdown>
        </uni-field>
        <uni-field class="col-span-6" label="Product Desc (Extended)">
          <input
            type="text"
            pInputText
            title="Product Description Extended"
            [(ngModel)]="productTypeDescriptionExt"
            (change)="onWhereChange()"
          />
          <p-dropdown
            extendedLabel
            class="small-dropdown"
            [options]="filterQueryOps"
            [(ngModel)]="productTypeDescriptionExtOp"
            optionLabel="name"
            dataKey="name"
            placeholder="Select a filter"
            (onChange)="onWhereChange()"
          >
          </p-dropdown>
        </uni-field>
      </div>
    </div>

    <!-- Section 2: Feature Filters -->
    <div class="qb-detail-card mx-4 mb-2 shrink-0 p-3">
      <div class="flex gap-4">
        <!-- Product Tags + And/Or -->
        <div class="w-1/5">
          <uni-field label="Product Tags">
            <p-multiSelect
              [options]="allProductTypeTags"
              [(ngModel)]="selectedProductTypeTags"
              defaultLabel="Select tags"
              optionLabel="name"
              dataKey="id"
              display="chip"
              (onChange)="onWhereChange()"
            ></p-multiSelect>
          </uni-field>
          <div class="mt-1 flex items-center gap-3">
            <span class="product-search__muted-label text-sm">Tags:</span>
            <p-radioButton
              name="tagAndOr"
              value="and"
              [(ngModel)]="productTypeTagsAndOr"
              inputId="tagAnd"
              (onClick)="onWhereChange()"
            ></p-radioButton>
            <label class="text-sm" for="tagAnd">And</label>
            <p-radioButton
              name="tagAndOr"
              value="or"
              [(ngModel)]="productTypeTagsAndOr"
              inputId="tagOr"
              (onClick)="onWhereChange()"
            ></p-radioButton>
            <label class="text-sm" for="tagOr">Or</label>
          </div>
        </div>

        <!-- Features dropdown + Delete -->
        <div class="product-search__narrow-col">
          <uni-field label="Features">
            <p-dropdown
              [disabled]="allFeatures.length === 0"
              [options]="allFeatures"
              [(ngModel)]="selectedFeature"
              optionLabel="name"
              [showClear]="false"
              dataKey="id"
              placeholder="Select a Feature"
              (onChange)="onSelectedFeatureChange()"
            >
            </p-dropdown>
          </uni-field>
          <div class="mt-1">
            <p-button
              styleClass="p-button-sm p-button-text"
              icon="pi pi-trash"
              [disabled]="!selectedFeature"
              (onClick)="onDeleteFeature(this.selectedFeature)"
              label="Remove"
            >
            </p-button>
          </div>
        </div>

        <!-- Feature Choices -->
        <div class="product-search__choices-col">
          <uni-field label="Feature Choices">
            <p-multiSelect
              [disabled]="featureChoices.length === 0"
              [options]="featureChoices"
              [(ngModel)]="selectedFeatureChoices"
              optionLabel="choiceValue"
              dataKey="id"
              [filter]="false"
              [showClear]="false"
              [selectionLimit]="maxFeatureChoices"
              [maxSelectedLabels]="0"
              placeholder="Select choices"
              (onChange)="onFeatureChoiceChange()"
            >
            </p-multiSelect>
          </uni-field>
          <div class="mt-1 flex items-center gap-3">
            <span class="product-search__muted-label text-sm">Features:</span>
            <p-radioButton
              name="featAndOr"
              value="and"
              [(ngModel)]="featuresAndOr"
              inputId="featAnd"
              (onClick)="onWhereChange()"
            ></p-radioButton>
            <label class="text-sm" for="featAnd">And</label>
            <p-radioButton
              name="featAndOr"
              value="or"
              [(ngModel)]="featuresAndOr"
              inputId="featOr"
              (onClick)="onWhereChange()"
            ></p-radioButton>
            <label class="text-sm" for="featOr">Or</label>
          </div>
        </div>

        <!-- Show All Features checkbox -->
        <div class="pt-9">
          <p-checkbox
            [binary]="true"
            inputId="showAllFeatures"
            [(ngModel)]="shouldShowAllFeatures"
            (onChange)="onShowFeaturesChange()"
          ></p-checkbox>
          <label for="showAllFeatures" class="ml-2 whitespace-nowrap text-sm">Show all features</label>
        </div>
      </div>

      <!-- Feature Search Criteria Summary -->
      <div *ngIf="searchFeatures.length > 0" class="product-search__criteria-divider mt-3 pt-3">
        <div class="flex flex-wrap items-center gap-2">
          <span class="product-search__muted-label text-sm font-semibold">Active Criteria:</span>
          <ng-container *ngFor="let feature of searchFeatures">
            <span class="product-search__criteria-chip cursor-pointer rounded px-2 py-1 text-sm" (click)="onCriteriaClick(feature)">
              <strong>{{ feature.name }}</strong
              ><span *ngIf="formatSelectedChoices(feature)">: {{ formatSelectedChoices(feature) }}</span>
            </span>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Results Grid -->
    <app-ag-grid [gridOptions]="productGridOptions" class="min-h-0 flex-1"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
